/**
 * @return {String}
 */
export default function faqUrl() {
  if(window.location.href.indexOf("/card") > -1) {
    return "https://sunbit.com/im-a-consumer/sunbit-card-faq/";
  }
  return `https://sunbit.com/im-a-consumer/customer-service/`;
}



// WEBPACK FOOTER //
// ./src/utils/url/faqUrl.js